export default __webpack_public_path__ + "images/5784e712e5d866890fa2f43783412ebc-medicine.jpg";